import React, { FC } from 'react';
import { BottomNavigation, BottomNavigationAction, makeStyles } from '@material-ui/core';
import LocalParking from '@material-ui/icons/LocalParking';
import Computer from '@material-ui/icons/Computer';
import Search from '@material-ui/icons/Search';
import AllInbox from '@material-ui/icons/AllInbox';
import Build from '@material-ui/icons/Build';

interface Props {
  currentPage: number;
  handleChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
  currentNav: {
    location: boolean;
    device: boolean;
    search: boolean;
    log: boolean;
    manage: boolean;
  };
}

const useStyles = makeStyles({
  stickToBottom: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
  },
  button: {
    minWidth: "unset",
  }
});

const BottomNav: FC<Props> = ({ currentPage, handleChange, currentNav }) => {
  const classes = useStyles();

  return (
    <BottomNavigation
      value={currentPage}
      onChange={handleChange}
      showLabels
      className={classes.stickToBottom}
    >
      {currentNav.location && (
        <BottomNavigationAction disabled={!currentNav.location} className={classes.button} label="Pladser" icon={<LocalParking />} />
      )}
      {currentNav.device && (
        <BottomNavigationAction disabled={!currentNav.device} className={classes.button} label="Automater" icon={<Computer />} />
      )}
      {currentNav.search && (
        <BottomNavigationAction disabled={!currentNav.search} className={classes.button} label="Søg" icon={<Search />} />
      )}
      {currentNav.log && (
        <BottomNavigationAction disabled={!currentNav.log} className={classes.button} label="Log" icon={<AllInbox />} />
      )}
      {currentNav.manage && (
        <BottomNavigationAction disabled={!currentNav.manage} className={classes.button} label="Administrer" icon={<Build />} />
      )}
    </BottomNavigation>
  );
};

export default BottomNav;